
import Vue from 'vue';
import Axios from 'axios';
import { Field, Module } from '@/plugins/customData';
import { TransactionInsight } from '@/plugins/iovation';
import { ApiData } from '@/plugins/apiData';
import { EventBus } from '@/plugins/eventBus';
import FraudForce from '@/components/FraudForce.vue';
import { GetValue, CheckNullFields } from '../../plugins/utilities';
import DeviceVerify from '@/components/DeviceVerify.vue';

export default Vue.extend({
  name: 'ModuleFields',
  components: {
      FraudForce,
      DeviceVerify,
  },
  data: () => ({
    fields: Array<Field>(),
    lkUser: '',
    ffUser: 'braddschick@iovation.com',
    modData: {
        id: -1,
        name: '',
        actionName: '',
        ruleSet: '',
        isFF: false,
        isCK: false,
        isLK: false,
        isDV: false,
        isPF: false,
    },
    transIn: Array<TransactionInsight>(),
    isTi: false,
    isDV: false,
    isFFCK: false,
    isLK: false,
    isPF: false,
    isEmailPhone: false,
    goFF: false,
    goLK: false,
    goDV: false,
    goPF: false,
    origin: window.location.origin,
  }),
  props: {
    moduleId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    removeUnderScores(txt: string): string {
        return txt.replace(/_/gi, ' ');
    },
    getUserId(): string {
        const userid = document.querySelector('#UserId');
        if (userid) {
            return GetValue(userid, 'value');
        } else {
            return 'bradd.schick@iovation.com';
        }
    },
    getModule(): void {
        const db = new ApiData({
            id: this.moduleId.toString(),
            command: 'get_module',
        });
        db.send()
        .then((result) => {
            if (result.data.module) {
                this.modData = result.data.module;
                this.assignProps();
            }
            if (result.data.fields) {
                this.fields = result.data.fields;
                this.isTi = this.hasTi();
            }
        })
        .catch((reason) => {
            EventBus.$emit('message', { context: 'error', message: reason.message });
        });
    },
    hasTi(): boolean {
        const test = this.fields.filter((x) => x.isTI === 1);
        return test.length > 0;
    },
    hasEmailOrPhone(): boolean {
        const test = this.fields.filter((x) => x.isEmail === 1);
        const test2 = this.fields.filter((x) => x.isPhone === 1);
        return test.length > 0 || test2.length > 0;
    },
    assignProps(): void {
        this.isFFCK = (this.modData.isFF || this.modData.isCK);
        this.isDV = this.modData.isDV;
        this.isLK = this.modData.isLK;
        this.isPF = this.modData.isPF;
    },
    modAction(): void {
        if (CheckNullFields(document.querySelectorAll('input'))) {
            if (this.isFFCK) {
              this.goFF = true;
            }
            if (this.isDV) {
              this.goDV = true;
            }
            if (this.isLK) {
              this.goLK = true;
            }
        } else {
            EventBus.$emit('message', { context: 'info', text: 'You need to fill all the values' });
        }
    },
    fireTi(evt: FocusEvent): void {
        if (evt.target && (evt.target as any).id && (evt.target as any).value) {
            this.transIn.push({ name: (evt.target as any).id, value: (evt.target as any).value });
        }
    },
    fireUser(evt: FocusEvent): void {
        if (evt.target && (evt.target as any).id && (evt.target as any).value) {
            // this.transIn.push({ name: (evt.target as any).id, value: (evt.target as any).value });
            if ((evt.target as any).id === 'LaunchKeyUser') {
                this.lkUser = (evt.target as any).value;
            }
            if ((evt.target as any).id === 'UserId') {
                this.ffUser = (evt.target as any).value;
            }
        }
    },
  },
  mounted() {
    this.getModule();
  },
});
